import { __awaiter, __generator } from "tslib";
import { inlineTextAreaKey } from './';
export var createInlineTextAreaDriver = function (wrapper) {
    var base = wrapper.$("." + inlineTextAreaKey);
    var maybeCustomView = base.$('.custom-view').exists();
    return {
        getDisplayedText: function () { return base.text(); },
        getValue: function () { return base.$('textarea').value(); },
        setValue: function (value) { return base.$('textarea').enterValue(value); },
        disabled: function () { return base.hasClass('disabled'); },
        onHover: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, maybeCustomView];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/, base.$('.custom-view').hover()];
                        }
                        else {
                            return [2 /*return*/, base.$('.unfocused-body').hover()];
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        clickToEdit: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, maybeCustomView];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/, base.$('.custom-view').click()];
                        }
                        else {
                            return [2 /*return*/, base.$('.unfocused-body').click()];
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        showingTextarea: function () { return base.$('.textarea-container').exists(); },
        clickClear: function () { return base.$('.clear-button').click(); },
        isClearDisabled: function () { return base.$('.clear-button.disabled').exists(); },
        clickConfirm: function () { return base.$('.confirm-button').click(); },
        isConfirmDisabled: function () { return base.$('.confirm-button.disabled').exists(); },
        clickCancel: function () { return base.$('.cancel-button').click(); },
        isCancelDisabled: function () { return base.$('.cancel-button.disabled').exists(); },
        expandButtonExists: function () { return base.$('.expand-button').exists(); },
        isLoading: function () { return base.$('.tiny-loader').exists(); },
        isDisabled: function () { return base.$('.unfocused-body').hasClass('disabled'); },
        base: base,
    };
};
//# sourceMappingURL=driver.js.map